import { DatabaseService } from './database.service';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';



@NgModule({
  declarations: [],
  providers: [
    // DatabaseService
  ],
  imports: [
    CommonModule
  ]
})
export class OfflineDatabaseModule { }
